export default __webpack_public_path__ + "static/partner-01211012aceeb10c5be2be3ac63d6411.png";